/** @module csi/datasheet/Thumbnail */
define([
	"dojo/_base/declare",
	"dijit/_TemplatedMixin",
	"dijit/_WidgetBase",
	"dijit/_WidgetsInTemplateMixin",
	"csi/html",
	"dojo/text!./Thumbnail.html",

	"csi/widget/SplitPane"
], function(declare,_TemplatedMixin,_WidgetBase,_WidgetsInTemplateMixin,html,template) {

	return declare([_WidgetBase,_TemplatedMixin,_WidgetsInTemplateMixin], {
		baseClass: "csi-theme-canvas-thumbnail",
		templateString: template,

		// extension points
		indexNode: null,
		deleteNode: null,
		notesNode: null,
		splitNode: null,
		svgNode: null,

		/** @property {number} index - index of page */
		index: 1,

		/** @property {boolean} hasNotes - indicates if notes are present on page */
		hasNotes: false,

		/** @property {string} snapshot - src for snapshot image - rendered if svg content not present */
		snapshot: "",

		/** @property {number} snapshotHeight - height of snapshot image */
		snapshotHeight: 0,

		/** @property {number} split - percentage from 0-1 indicating size of SVG content relative to notes */
		split: "",

		/** @property {string} svg - svg content */
		svg: "",

		/** @property {boolean} vertical - indicates if thumbnail is oriented vertically (static) */
		vertical: false,

		_renderSvg: function() {
			var svgNode = $(this.svgNode);

			svgNode.empty();

			if (this.svg) {
				svgNode.html(this.svg);
			} else if (this.snapshot && this.snapshotHeight) {
				html.create("img", {
					src: this.snapshot,
					style: "height:" + this.snapshotHeight + "px"
				}, this.svgNode);
			}
		},

		_setIndexAttr: {node: "indexNode", type: "innerText"},

		/**
		 * Show notes node when they exist
		 * @param {boolean} value
		 */
		_setHasNotesAttr: function(value) {
			this._set("hasNotes", value);
			$(this.notesNode).toggleClass("hidden", !value);
		},

		/**
		 * Set SVG snapshot and update rendering
		 * @param {string} value
		 */
		_setSnapshotAttr: function(value) {
			this._set("snapshot", value);
			this._renderSvg();
		},

		/**
		 * Set SVG snapshot height and update rendering
		 * @param {number} value
		 */
		_setSnapshotHeightAttr: function(value) {
			this._set("snapshotHeight", value);
			this._renderSvg();
		},

		/**
		 * Set SVG content and update rendering
		 * @param {string} value
		 */
		_setSvgAttr: function(value) {
			this._set("svg", value);
			this._renderSvg();
		},

		/**
		 * Apply split percentage to splitNode
		 * @param {number} value
		 */
		_setSplitAttr: function(value) {
			this._set("split", value);
			this.splitNode.set("split", value);
		}
	});
});